module.exports = __webpack_public_path__ + "img/google.763e06b6.svg";